<mat-form-field class="full-width form-field textarea" style="height: 100%;">
  <mat-label>{{label}}</mat-label>
  <textarea matInput
    id="ip{{label | stripSpaces}}" 
    [(placeholder)]="label" 
    [(ngModel)]="value"
    [required]="required" 
    [minlength]="min" 
    [maxlength]="max" 
    [disabled]="readonly"
    (input)=input(value)
    #ip="ngModel"
    attr.aria-label="{{label}}">
  </textarea>
</mat-form-field>
<validation-errors [control]="ip" [min]="min" [max]="max"></validation-errors>
